import { render, staticRenderFns } from "./WineListSettings.vue?vue&type=template&id=39338b48&"
import script from "./WineListSettings.vue?vue&type=script&lang=js&"
export * from "./WineListSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports